module.exports = __webpack_public_path__ + "static/img/1.ca908cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/sp/1.png
// module id = jbVM
// module chunks = 0